import images1 from "../../assets/yo.jpg";
import images2 from "../../assets/react-l.png"
import images3 from "../../assets/logoOG.png"

export const testimonialsData = [
  {
    image: images1,
    review:
  "Hola!, soy programador y es algo que me apasiona desde que lo descubrí. Soy argentino y me gusta viajar, tomar mate y pasear con mi mascota",
    name: 'Alberto Zalazar',
    status : 'FullStack Dev'
  },
  {
    image: images2,
    review: 'La mayor parte de mi tiempo me especializo conociendo mas sobre las tecnologias disponibles y a mi alcance, para profundizar mi conocimiento, tanto en materia del Back-End, como de Front-End',
    name: 'Alberto Zalazar',
    status : 'FullStack Dev'
  },
  {
    image : images3,
    review:'Mis conocimientos los obtuve de manera autodidacta, y los reforce, a traves del Bootcamp de SoyHenry, ahondando mas en tecnologias como Node.js, SQL, React, Redux, entre otras',
    name: 'Alberto Zalazar',
    status : 'FullStack Dev'
  }
];